import React from "react";
import Page from "../templates/support/wellbing/wellbing";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
